module.exports = require("./fr-PF");